import * as tslib_1 from "tslib";
import { OnInit, ElementRef } from '@angular/core';
import { AlertController, LoadingController, Events, Platform, ModalController, NavParams } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user/user.service';
import { StatesModalPage } from '../states-modal/states-modal.page';
import { LabelService } from 'src/app/services/label/label.service';
import { ConfigService } from '../services/config/config.service';
import { MapPage } from './map/map.page';
import { MultiCountriesService } from '../services/multi-countries/multi-countries.service';
var NewAddressPage = /** @class */ (function () {
    function NewAddressPage(events, router, alertController, loadingController, route, userService, platform, navParams, labelService, modalController, configService, multiCountriesService) {
        this.events = events;
        this.router = router;
        this.alertController = alertController;
        this.loadingController = loadingController;
        this.route = route;
        this.userService = userService;
        this.platform = platform;
        this.navParams = navParams;
        this.labelService = labelService;
        this.modalController = modalController;
        this.configService = configService;
        this.multiCountriesService = multiCountriesService;
        this.addressObj = {
            name: '',
            address: '',
            city: '',
            state: '',
            stateCode: '',
            pincode: '',
            phoneNo: '',
            createdAt: null,
            defaultAddress: true,
            lat: null,
            lng: null,
            country: '',
            additionalPhoneNo: '',
        };
        this.routeFromCheckoutPage = false;
        this.routeFromSelectAddress = false;
        this.routeFromMyAddresses = false;
        this.states = [];
        this.addressType = 'shipping';
        this.SHARED_LABELS = {};
        this.NEW_ADDRESS_LABELS = {};
        this.countries = [];
        this.pageType = 'page';
        if (navParams.get('addressData')) {
            this.editAddressData = navParams.get('addressData');
        }
        if (navParams.get('addressLength')) {
            this.addressLength = navParams.get('addressLength');
        }
        if (navParams.get('routeFromCheckoutPage')) {
            this.routeFromCheckoutPage = navParams.get('routeFromCheckoutPage');
        }
        if (navParams.get('routeFromSelectAddress')) {
            this.routeFromSelectAddress = navParams.get('routeFromSelectAddress');
        }
        if (navParams.get('routeFromMyAddresses')) {
            this.routeFromMyAddresses = navParams.get('routeFromMyAddresses');
        }
        if (navParams.get('type')) {
            this.addressType = navParams.get('type');
        }
        this.geoCoder = new google.maps.Geocoder;
        console.log('routeFromSelectAddress', this.routeFromSelectAddress);
    }
    NewAddressPage.prototype.ngOnInit = function () { };
    NewAddressPage.prototype.ionViewDidEnter = function () {
        this.initializeSubscriptions();
        this.addressObj.phoneNo = this.userService.getPhoneNo();
        this.SHARED_LABELS = this.labelService.labels['SHARED'];
        this.NEW_ADDRESS_LABELS = this.labelService.labels['NEW_ADDRESS'];
        this.countries = this.multiCountriesService.multiCountriesSettings.countries;
    };
    NewAddressPage.prototype.ionViewDidLeave = function () {
        this.removeSubscriptions();
    };
    NewAddressPage.prototype.modalDismiss = function () {
        this.modalController.dismiss();
    };
    NewAddressPage.prototype.initializeSubscriptions = function () {
        var _this = this;
        this.events.subscribe('user:newAddressSaved', function () {
            _this.loading.dismiss();
            if (_this.routeFromCheckoutPage === true || _this.routeFromSelectAddress === true) {
                _this.modalDismiss();
                _this.router.navigate(['order-summary']);
            }
            else {
                if (_this.pageType === 'modal') {
                    _this.modalController.dismiss({ close: false });
                }
                else {
                    _this.presentAlert("" + _this.NEW_ADDRESS_LABELS['address_saved_successfully'], true);
                }
            }
        });
        this.events.subscribe('user:addressEditSuccess', function () {
            _this.loading.dismiss();
            _this.modalDismiss();
            console.log('routeFromSelectAddress', _this.routeFromSelectAddress);
            if (_this.routeFromSelectAddress === true) {
                _this.router.navigate(['order-summary']);
            }
            else {
                if (_this.pageType === 'modal') {
                    _this.modalController.dismiss({ close: false });
                }
                else {
                    _this.presentAlert("" + _this.NEW_ADDRESS_LABELS['address_edited_successfully'], true);
                }
            }
        });
        this.events.subscribe('user:errorInGettingAddress', function () {
            _this.loading.dismiss();
            _this.presentAlert("" + _this.NEW_ADDRESS_LABELS['error_in_getting_address']);
        });
        this.events.subscribe('user:addressValueFromLatLng', function (response) {
            _this.loading.dismiss();
            //// console.log('address', response);
            _this.getAddressFromResponse(response.results[0]);
        });
    };
    NewAddressPage.prototype.getAddressFromResponse = function (data) {
        if (!this.editAddressData) {
            this.addressObj.address = data.formatted_address;
            this.addressFromApi = data.formatted_address;
            for (var index = 0; index < data.address_components.length; index++) {
                for (var x = 0; x < data.address_components[index].types.length; x++) {
                    if (data.address_components[index].types[x] === "postal_code") {
                        this.addressObj.pincode = data.address_components[index].long_name;
                    }
                }
            }
        }
        else {
            this.editAddressData.address = data.formatted_address;
            this.addressFromApi = data.formatted_address;
            for (var index = 0; index < data.address_components.length; index++) {
                for (var x = 0; x < data.address_components[index].types.length; x++) {
                    if (data.address_components[index].types[x] === "postal_code") {
                        this.editAddressData.pincode = data.address_components[index].long_name;
                    }
                }
            }
        }
    };
    NewAddressPage.prototype.onClickSaveAddress = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.addressObj.name = this.addressObj.name.trim();
                        this.addressObj.city = this.addressObj.city.trim();
                        if (!(this.addressObj.name === '')) return [3 /*break*/, 1];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_name']);
                        return [3 /*break*/, 8];
                    case 1:
                        if (!(this.addressObj.address === '')) return [3 /*break*/, 2];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_address']);
                        return [3 /*break*/, 8];
                    case 2:
                        if (!(this.addressObj.city === '')) return [3 /*break*/, 3];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_city']);
                        return [3 /*break*/, 8];
                    case 3:
                        if (!(this.addressObj.state === '')) return [3 /*break*/, 4];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_state']);
                        return [3 /*break*/, 8];
                    case 4:
                        if (!(this.addressObj.pincode === '')) return [3 /*break*/, 5];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_pincode']);
                        return [3 /*break*/, 8];
                    case 5:
                        if (!(this.addressObj.phoneNo === '')) return [3 /*break*/, 6];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_phoneno']);
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.presentLoading()];
                    case 7:
                        _a.sent();
                        this.addressObj.createdAt = new Date();
                        if (this.addressFromApi === this.addressObj.address) {
                            this.addressObj.lat = this.latitude;
                            this.addressObj.lng = this.longitude;
                        }
                        this.events.publish('user:saveNewAddress', this.addressObj, this.addressType);
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    NewAddressPage.prototype.onClickEditAddress = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.editAddressData.name = this.editAddressData.name.trim();
                        this.editAddressData.city = this.editAddressData.city.trim();
                        if (!(this.editAddressData.name === '')) return [3 /*break*/, 1];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_name']);
                        return [3 /*break*/, 8];
                    case 1:
                        if (!(this.editAddressData.address === '')) return [3 /*break*/, 2];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_address']);
                        return [3 /*break*/, 8];
                    case 2:
                        if (!(this.editAddressData.city === '')) return [3 /*break*/, 3];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_city']);
                        return [3 /*break*/, 8];
                    case 3:
                        if (!(this.editAddressData.state === '')) return [3 /*break*/, 4];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_state']);
                        return [3 /*break*/, 8];
                    case 4:
                        if (!(this.editAddressData.pincode === '')) return [3 /*break*/, 5];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_pincode']);
                        return [3 /*break*/, 8];
                    case 5:
                        if (!(this.editAddressData.phoneNo === '')) return [3 /*break*/, 6];
                        this.presentAlert("" + this.NEW_ADDRESS_LABELS['please_enter_phoneno']);
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.presentLoading()];
                    case 7:
                        _a.sent();
                        this.editAddressData.createdAt = new Date();
                        if (this.addressFromApi === this.editAddressData.address) {
                            this.editAddressData.lat = this.latitude;
                            this.editAddressData.lng = this.longitude;
                        }
                        this.events.publish('user:editSavedAddress', this.editAddressData, this.addressType);
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    NewAddressPage.prototype.updateNewAddressDefaultStatus = function () {
        if (this.addressObj.defaultAddress === true || this.addressObj.defaultAddress === null) {
            this.addressObj.defaultAddress = false;
        }
        else {
            this.addressObj.defaultAddress = true;
        }
    };
    NewAddressPage.prototype.updateEditAddressDefaultStatus = function (status) {
        if (status === true) {
            this.editAddressData.status = false;
        }
        else {
            this.editAddressData.status = true;
        }
    };
    NewAddressPage.prototype.goToPage = function (page) {
        this.router.navigate([page]);
    };
    NewAddressPage.prototype.addressChange = function () {
        this.editAddressData.lat = null;
        this.editAddressData.lng = null;
    };
    NewAddressPage.prototype.openStateModal = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: StatesModalPage,
                            cssClass: 'custom-modal'
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss()
                            .then(function (res) {
                            //// console.log('data from modal', res);
                            if (res.data) {
                                //// console.log(res.data);
                                if (!_this.editAddressData) {
                                    _this.addressObj.state = res.data.state;
                                    _this.addressObj.stateCode = res.data.code;
                                }
                                else {
                                    _this.editAddressData.state = res.data.state;
                                    _this.editAddressData.stateCode = res.data.code;
                                }
                            }
                        });
                        return [4 /*yield*/, modal.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NewAddressPage.prototype.presentAlert = function (msg, action) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alert;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            message: msg,
                            buttons: [{
                                    text: 'Ok',
                                    handler: function () {
                                        //// console.log('Confirm Okay');
                                        if (action === true) {
                                            _this.router.navigate(['user-addresses']);
                                            _this.modalDismiss();
                                        }
                                    }
                                }]
                        })];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NewAddressPage.prototype.presentLoading = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.loadingController.create({
                                message: this.SHARED_LABELS['please_wait'],
                                duration: 10000
                            })];
                    case 1:
                        _a.loading = _b.sent();
                        return [4 /*yield*/, this.loading.present()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NewAddressPage.prototype.isPincodeValid = function () {
        var pincode = this.editAddressData ? this.editAddressData.pincode : this.addressObj.pincode;
        if (this.configService.environment.currencyCode === 'INR' && pincode.length && pincode.length < 6) {
            return false;
        }
        else {
            return true;
        }
    };
    NewAddressPage.prototype.getPincodeHeading = function () {
        if (this.configService.environment.currencyCode === 'INR') {
            return 'NEW_ADDRESS.pincode';
        }
        else {
            return 'NEW_ADDRESS.state_area_code';
        }
    };
    NewAddressPage.prototype.closeModal = function () {
        this.modalController.dismiss({ closed: true });
    };
    NewAddressPage.prototype.removeSubscriptions = function () {
        this.events.unsubscribe('user:newAddressSaved');
        this.events.unsubscribe('user:addressEditSuccess');
        this.events.unsubscribe('user:errorInGettingAddress');
        this.events.unsubscribe('user:addressValueFromLatLng');
    };
    NewAddressPage.prototype.showMapModal = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: MapPage,
                            cssClass: 'custom-modal'
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss()
                            .then(function (res) {
                            if (res.data) {
                                if (!_this.editAddressData) {
                                    console.log('address:', res.data);
                                    _this.addressObj.address = res.data.address;
                                    _this.addressObj.lat = res.data.location.lat;
                                    _this.addressObj.lng = res.data.location.lng;
                                }
                                else if (_this.editAddressData) {
                                    _this.editAddressData.address = res.data.address;
                                    _this.editAddressData.lat = res.data.location.lat;
                                    _this.editAddressData.lng = res.data.location.lng;
                                }
                            }
                        });
                        return [4 /*yield*/, modal.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // askLocationPermission(){
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     console.log('position:', position);
    //     // this.lat = position.coords.latitude;
    //     // this.lng = position.coords.longitude;
    //     // setTimeout(() => {
    //     //   this.loadMap();
    //     // }, 500);
    //   })
    // }
    NewAddressPage.prototype.onChangeCountry = function (e) {
        this[this.editAddressData ? 'editAddressData' : 'addressObj'].country = e.target.value;
    };
    NewAddressPage.prototype.phoneNumberValidation = function (event, type) {
        var pattern = /[0-9.,+]/;
        var inputChar = String.fromCharCode(event.charCode);
        if (type === 'new') {
            if (!pattern.test(inputChar) || this.addressObj.phoneNo.length >= 13) {
                event.preventDefault();
            }
        }
        else if (type === 'edit') {
            if (!pattern.test(inputChar) || this.editAddressData.phoneNo.length >= 13) {
                event.preventDefault();
            }
        }
    };
    NewAddressPage.prototype.textValidation = function (event) {
        var pattern = /[a-zA-Z]+$/;
        var inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    };
    NewAddressPage.prototype.getPincodeData = function (event) {
        var _this = this;
        // const Code= this.multiCountriesService.getMultiCountries();
        var country_Code = '';
        var pincode = "";
        var country = this[this.editAddressData ? 'editAddressData' : 'addressObj'].country;
        pincode = this.editAddressData ? this.editAddressData.pincode : this.addressObj.pincode;
        // console.log(pincode);
        var res = this.countries.forEach(function (element) {
            if (element.countryName === country) {
                // console.log(element.countryCode);
                country_Code = element.countryCode;
                // console.log(country_Code);
            }
        });
        // var res=this.multiCountriesService.getCountryCode(stat);
        // res.then(d =>{
        //   // console.log(d);
        var data = fetch("https://api.worldpostallocations.com?postalcode=" + pincode + "&countrycode=" + country_Code);
        data.then(function (res) {
            return res.json();
        }).then(function (g) {
            try {
                // this.isPincodeValid(pincode);
                if (!_this.editAddressData) {
                    _this.addressObj.state = g.result[0].state;
                    _this.addressObj.stateCode = g.result[0].stateId;
                    if (g.result[0].province != "NA") {
                        _this.addressObj.city = g.result[0].province;
                    }
                    else {
                        _this.addressObj.city = g.result[0].district;
                    }
                }
                else {
                    _this.editAddressData.state = g.result[0].state;
                    _this.editAddressData.stateCode = g.result[0].stateId;
                    if (g.result[0].province != "NA") {
                        _this.editAddressData.city = g.result[0].province;
                    }
                    else {
                        _this.editAddressData.city = g.result[0].district;
                    }
                }
            }
            catch (e) {
                // console.log("invalid Pincode");
                // console.log(e);
                // this.isPincodeValid();
            }
        });
        // });
        // console.log(pincode);
        // var upper=country_Code.toUpperCase();
        // console.log(country_Code);
    };
    NewAddressPage.prototype.getLocationUsingPinCode = function (pincode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                console.log("pincode", pincode);
                console.log("this.isPinCodeValid()", this.isPincodeValid());
                if (this.isPincodeValid()) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            _this.geoCoder.geocode({ 'address': pincode }, function (results, status) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var lat, lng, state;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(status == google.maps.GeocoderStatus.OK)) return [3 /*break*/, 4];
                                            lat = results[0].geometry.location.lat();
                                            lng = results[0].geometry.location.lng();
                                            console.log("lat, lng", lat, lng);
                                            return [4 /*yield*/, this.getGeoCodedAddress(lat, lng)];
                                        case 1:
                                            state = _a.sent();
                                            console.log("state", state);
                                            if (!state) return [3 /*break*/, 3];
                                            return [4 /*yield*/, this.setLocationInAddress(state)];
                                        case 2:
                                            _a.sent();
                                            _a.label = 3;
                                        case 3:
                                            resolve(true);
                                            return [3 /*break*/, 5];
                                        case 4:
                                            console.log('Geocoder error!');
                                            resolve(false);
                                            _a.label = 5;
                                        case 5: return [2 /*return*/];
                                    }
                                });
                            }); });
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    NewAddressPage.prototype.getGeoCodedAddress = function (lat, lng) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var city, state, country, latLng, request_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!navigator.geolocation) return [3 /*break*/, 3];
                        return [4 /*yield*/, new google.maps.LatLng(lat, lng)];
                    case 1:
                        latLng = _a.sent();
                        request_1 = { latLng: latLng };
                        return [4 /*yield*/, new Promise(function (resolve) {
                                _this.geoCoder.geocode(request_1, function (results, status) {
                                    if (status === google.maps.GeocoderStatus.OK) {
                                        var result = results[0];
                                        var resultAddressComponent = result.address_components;
                                        console.log("resultAddressComponent", resultAddressComponent);
                                        for (var _i = 0, resultAddressComponent_1 = resultAddressComponent; _i < resultAddressComponent_1.length; _i++) {
                                            var address = resultAddressComponent_1[_i];
                                            for (var _a = 0, _b = address.types; _a < _b.length; _a++) {
                                                var addressTypes = _b[_a];
                                                if (addressTypes === 'locality') {
                                                    console.log("City locality: ", address.long_name);
                                                    city = address.long_name;
                                                }
                                                if (addressTypes === 'administrative_area_level_1') {
                                                    console.log("State administrative_area_level_1: ", address.long_name);
                                                    state = address.long_name;
                                                }
                                                if (addressTypes === 'country') {
                                                    console.log("Country: ", address.long_name);
                                                    country = address.long_name;
                                                }
                                            }
                                        }
                                        if (result !== null) {
                                            resolve(true);
                                        }
                                        else {
                                            alert('Unable to get your precise location.');
                                            resolve(false);
                                        }
                                    }
                                    else {
                                        console.log('Geocoder error!');
                                        resolve(false);
                                    }
                                });
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, { state: state, city: city, country: country }];
                }
            });
        });
    };
    NewAddressPage.prototype.setLocationInAddress = function (state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.editAddressData) {
                    this.addressObj.city = state.city || '';
                    this.addressObj.state = state.state || '';
                    this.addressObj.country = state.country || '';
                }
                else {
                    this.editAddressData.city = state.city || '';
                    this.editAddressData.state = state.state || '';
                    this.editAddressData.country = state.country || '';
                }
                return [2 /*return*/];
            });
        });
    };
    return NewAddressPage;
}());
export { NewAddressPage };
